import React from "react";
import { Chart, Bar } from "react-chartjs-2";

let BarComponent = React.memo((props) => {
  return (
    <Bar
      data={{
        labels: ["A", "B", "C", "D", "E", "F"],
        datasets: [
          {
            label: props.mainCountry,
            data: [
              props.mainA,
              props.mainB,
              props.mainC,
              props.mainD,
              props.mainE,
              props.mainF,
            ],
            color: "black",
            backgroundColor: [
              "#145214",
              "#2eb82e",
              "#85e085",
              "#cccc00",
              "#ff9900",
              "#e62e00",
            ],
            hoverBackgroundColor: [
              "#145214",
              "#2eb82e",
              "#85e085",
              "#cccc00",
              "#ff9900",
              "#e62e00",
            ],
            borderColor: [
              "#ca0020",
              "#ca0020",
              "#ca0020",
              "#ca0020",
              "#ca0020",
              "#ca0020",
            ],
            hoverBorderColor: [
              "#cccccc",
              "#cccccc",
              "#cccccc",
              "#cccccc",
              "#cccccc",
              "#cccccc",
            ],

            borderRadius: 2,
            borderWidth: 2,

            hoverOffset: 4,
          },
          {
            label: props.comparedCountry,
            data: [
              props.comparedA,
              props.comparedB,
              props.comparedC,
              props.comparedD,
              props.comparedE,
              props.comparedF,
            ],
            color: "black",
            backgroundColor: [
              "#145214",
              "#2eb82e",
              "#85e085",
              "#cccc00",
              "#ff9900",
              "#e62e00",
            ],
            hoverBackgroundColor: [
              "#145214",
              "#2eb82e",
              "#85e085",
              "#cccc00",
              "#ff9900",
              "#e62e00",
            ],
            borderColor: [
              "#f4a582",
              "#f4a582",
              "#f4a582",
              "#f4a582",
              "#f4a582",
              "#f4a582",
            ],
            hoverBorderColor: [
              "#cccccc",
              "#cccccc",
              "#cccccc",
              "#cccccc",
              "#cccccc",
              "#cccccc",
            ],

            borderRadius: 2,
            borderWidth: 2,

            hoverOffset: 4,
          },
        ],
      }}
      options={{
        responsive: true,
        plugins: {
          legend: {
            labels: {
              color: "black",
              generateLabels: function (chart) {
                let labels =
                  Chart.defaults.plugins.legend.labels.generateLabels(chart);
                labels[0].fillStyle = "transparent";
                labels[0].strokeStyle = "#ca0020";
                labels[0].fontColor = "#ca0020";
                labels[0].fontWeight = 700;
                labels[1].fillStyle = "transparent";
                labels[1].fontColor = "#f4a582";
                labels[1].fontWeight = 700;
                labels[1].strokeStyle = "#f4a582";
                return labels;
              },
            },
            position: "bottom",
          },
        },
      }}
    />
  );
});

export default BarComponent;
